import React, { useEffect } from 'react';

const IntercomChat = () => {
  useEffect(() => {
    // Standard Intercom snippet for loading the script
    (function() {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic('reattach_activator');
        ic('update', w.intercomSettings || {});
      } else {
        var d = document;
        var i = function() {
          i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function() {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/q7g7m1ah';
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();

    // Initialize with just the app_id
    window.Intercom('boot', {
      app_id: 'q7g7m1ah',
      // Since this is a public website without user authentication,
      // we'll only pass the app_id without user-specific data
      // If you add user authentication later, you can update this to include:
      // user_id, name, email, created_at, etc.
    });

    // Clean up function to shut down Intercom when component unmounts
    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default IntercomChat;
